import SelectionCardAvantgardeImpl from './selection-card-avantgarde.js';
import MojitoCore from 'mojito/core';
import { propTypes, defaultProps } from 'modules/event-cards/selection/prop-types.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Avantgarde design style selection card. Leads with a category badge that names the promotion the
 * selection came from, using a separate badge when the selection carries a price boost.
 *
 * @function SelectionCardAvantgarde
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Selection.Avantgarde
 */

/**
 * Avantgarde selection card prop types.
 *
 * @extends Mojito.Modules.EventCards.Selection.SelectionCardPropTypes
 *
 * @memberof Mojito.Modules.EventCards.Selection.Avantgarde.view
 */

export default UIView(
    'SelectionCardAvantgarde',
    SelectionCardAvantgardeImpl,
    propTypes,
    defaultProps
);
